/**
 * Cookie consent from Cookiebot (script in index.html). Trackers load only for the categories the
 * visitor accepted: PostHog = statistics, Meta Pixel = marketing. No Cookiebot on the page (blocked,
 * unregistered dev host) = no consent = nothing loads; a later accept re-runs the callback.
 */
export type Consent = { statistics: boolean; marketing: boolean }

type Cookiebot = {
  consent?: { statistics?: boolean; marketing?: boolean }
  hasResponse?: boolean
}

declare global {
  interface Window {
    Cookiebot?: Cookiebot
  }
}

export const NO_CONSENT: Consent = { statistics: false, marketing: false }

/** Current state from the Cookiebot object; `null` when the visitor has not answered yet. */
export function readConsent(cb: Cookiebot | undefined): Consent | null {
  if (!cb?.hasResponse || !cb.consent) return null
  return { statistics: cb.consent.statistics === true, marketing: cb.consent.marketing === true }
}

/**
 * Calls `cb` with the consent as soon as it is known and again on every change. Cookiebot fires
 * `CookiebotOnConsentReady` when the state is loaded from its cookie or submitted in the banner.
 */
export function onConsent(cb: (consent: Consent) => void): void {
  const now = readConsent(window.Cookiebot)
  if (now) cb(now)
  window.addEventListener('CookiebotOnConsentReady', () => {
    cb(readConsent(window.Cookiebot) ?? NO_CONSENT)
  })
}
